import * as React from "react";
const SvgCallTrackingMetrics = (props, ref) => (
  <svg
    viewBox="0 0 400 505.04"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    {...{ ...props, ref }}
  >
    <path
      d="M199.71,144.87c-99.46,0-180.09,80.62-180.1,180.08S100.23,505,199.69,505.05a180.08,180.08,0,0,0,180.1-180C379.79,225.31,297.75,144.87,199.71,144.87Zm0,305.74A123.26,123.26,0,1,1,323,327.35C323,395.79,268.54,450.61,199.71,450.61Z"
      fill="#02bdf6"
    />
    <path
      d="M383.79,54.83C331,21.61,266.54,0,199.71,0S68.45,21.61,15.62,54.83C0,66.43-4,88,4,103.65l25.61,46.82c6,9.61,19.61,13.61,27.61,6,15.61-11.6,31.22-23.61,48.82-31.21a10.83,10.83,0,0,0,6-9.61V88c0-4,2-8,6-8,25.61-9.61,52.83-13.61,80.44-13.61h4c27.61,0,54.83,4,80.44,13.61,4,0,6,4,6,8v27.61c0,4,2,8,6,9.61,17.61,8,33.22,19.61,48.83,31.21,8,8,21.61,4,27.61-6L397,103.65C403.4,88,399.8,66.43,383.79,54.83Z"
      fill="#02bdf6"
    />
    <circle cx="199.71" cy="325.35" r="66.43" fill="#02bdf6" />
  </svg>
);
export default React.forwardRef(SvgCallTrackingMetrics);
